'use client'

import Image from 'next/image'
import Link from 'next/link'

import { useHeaderChrome } from '@/components/layout/site-header-shell'
import { resolveImageSrc } from '@/lib/image-src'
import { cn } from '@/lib/utils'

/**
 * Логоны ДООР гарах уриа. Зөвхөн өргөн дэлгэц дээр — нарийн дээр цэсийг шахна.
 *
 * CMS-ийн «Сайтын тохиргоо» хэсэгт бөглөх хүртэл энэ утга үйлчилнэ.
 */
const FALLBACK_SLOGAN = 'WE BUILD PREMIUM BRANDS'

/**
 * Сайтын үндсэн лого ба уриа.
 *
 * Нүүр хуудсанд толгой нь эхлээд ТУНГАЛАГ, слайдер зураг дээр хөвдөг — тэр үед
 * өнгөт лого нь бараан зураг дээр уншигдахгүй тул ЦАГААН хувилбарт шилжинэ.
 * Доош гүйлгэж толгой цагаан болмогц өнгөт лого буцаж ирнэ.
 *
 * Төлөвийг `SiteHeaderShell`-ийн контекстээс уншина; хөл хэсэгт дуудагдахад
 * контекстийн үндсэн утга (`solid: true`) хүчинтэй тул өнгөт лого гарна.
 */
export const SiteLogo = ({
  className,
  size = 70,
  slogan,
  logoUrl,
  logoWhiteUrl
}: {
  className?: string
  size?: number

  /* Серверээс дамжина — энэ бол client component тул өөрөө татаж чадахгүй */
  slogan?: string | null
  logoUrl?: string | null
  logoWhiteUrl?: string | null
}) => {
  const { solid } = useHeaderChrome()

  /* Лого урдаа, уриа нь ХАЖУУД нь (2026-09-09, захиалагчийн заавар) */
  return (
    <Link href='/' className={cn('flex items-center gap-3', className)} aria-label='MAXIMUS — нүүр хуудас'>
      {/*
        Хоёуланг нь render хийж НУУНА — солигдох бүрт шинэ файл татвал эхний
        солилт дээр лого хэсэг зуур алга болно.
      */}
      <span className='relative shrink-0' style={{ width: size, height: size }}>
        <Image
          src={resolveImageSrc(logoUrl) ?? '/images/logo.svg'}
          alt='MAXIMUS'
          width={size}
          height={size}
          priority
          className={cn('absolute inset-0 transition-opacity duration-300', solid ? 'opacity-100' : 'opacity-0')}
        />
        <Image
          src={resolveImageSrc(logoWhiteUrl) ?? '/images/logo_white.svg'}
          alt=''
          width={size}
          height={size}
          priority
          aria-hidden
          className={cn('absolute inset-0 transition-opacity duration-300', solid ? 'opacity-0' : 'opacity-100')}
        />
      </span>

      <span
        className={cn(
          'hidden text-xs font-medium tracking-[0.18em] whitespace-nowrap transition-colors duration-300 lg:block',
          solid ? 'text-muted-foreground' : 'text-white/80'
        )}
      >
        {slogan || FALLBACK_SLOGAN}
      </span>
    </Link>
  )
}
